// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../../assets/icons/check.svg?inline");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".autoApplicationModal__checklist[data-v-021bea72]{\n  list-style-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  padding-left:22px\n}\n.autoApplicationModal__checklist li[data-v-021bea72]{\n  margin-top:8px;\n  padding-top:10px;\n  padding-bottom:10px\n}\n.autoApplicationModal__footer[data-v-021bea72]{\n  min-height:0!important\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
